import { Component, Inject } from '@angular/core';
import * as angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';
import { AuthService } from '../../common/services/auth.service';

@Component({
  selector: 'error-404',
  template: `
    <div class="main-wrapper">
      <div class="sidebar-wrapper" *ngIf="isAuthenticated()">
        <sidebar></sidebar>
      </div>
      <div class="page-content-wrapper">
        <div class="page-scroll-wrapper">
          <div class="page-wrapper">
            <alert-box
              [data]="{
                icon: 'icon-general-404',
                title: 'response.404.title' | translate,
                description: 'response.404.message' | translate
              }"
            ></alert-box>
          </div>
        </div>
      </div>
    </div>
  `,
})
export class Error404Component {
  constructor(private authService: AuthService) {}

  isAuthenticated(): boolean {
    return this.authService.isAuthenticated();
  }
}

((window as any).xplenty as angular.IModule).directive(
  'error404',
  downgradeComponent({
    component: Error404Component,
  }),
);
